var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.001C20 18.2396 16.4183 16.001 12 16.001C7.58172 16.001 4 18.2396 4 21.001M12 13.001C9.23858 13.001 7 10.7624 7 8.00098C7 5.23955 9.23858 3.00098 12 3.00098C14.7614 3.00098 17 5.23955 17 8.00098C17 10.7624 14.7614 13.001 12 13.001Z",
    stroke: "#000",
    strokeWidth: 1.30952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.1e9f0fb76169319f999a7ee40b38cac3.svg";
export { ForwardRef as ReactComponent };